/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

const backendHost = process.env.REACT_APP_BACKEND_HOST;
export const API_BASE_URL = `${backendHost}/api`;
export const APPLICATION_BASE_URL = `${backendHost}/api/ApplicationForms/`;
export const ACTIVITY_EVENT_BASE_URL = `${backendHost}/api/ApplicationForms/{contributionType}/{activityEventId}`;
export const APPLICATIONS_BASE_URL = `${backendHost}/api/{tenant}/ApplicationForms/`;
export const APPLICATION_FLAGS_URL = `${backendHost}/api/{tenant}/ApplicationForms/flags/`;
export const QUESTION_ANSWERS_URL = `${backendHost}/api/{tenant}/QuestionAnswers/`;
export const APPLICATION_ACTIVITIES_EVENTS_URL = `${backendHost}/api/{tenant}/ApplicationActivitiesEvents/`;
export const USERPROFILE_ACTIVITIES_EVENTS_URL = `${backendHost}/api/{tenant}/UserprofileActivitiesEvents/`;
export const ADMIN_USER_BASE_URL = `${backendHost}/api/AdminUser/`;
export const MVP_AZURE_BENEFIT_BASE_URL = `${backendHost}/api/mvp/benefit/azure`;
export const RD_AZURE_BENEFIT_BASE_URL = `${backendHost}/api/rd/benefit/azure`;
export const MVP_M365_COPILOT_BENEFIT_BASE_URL = `${backendHost}/api/mvp/benefit/m365Copilot`;
export const RD_M365_COPILOT_BENEFIT_BASE_URL = `${backendHost}/api/rd/benefit/m365Copilot`;
export const EVENT_BASE_URL = `${backendHost}/api/Events/`;
export const PROFILE_BASE_URL = `${backendHost}/api/UserProfiles/`;
export const PROFILE_BLOCK_SHIPPING_BASE_URL = `${backendHost}/api/UserProfiles/BlockShipping`;
export const MVP_PROFILE_BLOCK_SHIPPING_BASE_URL = `${backendHost}/api/mvp/UserProfiles/BlockShipping`;
export const BENEFIT_BASE_URL = `${backendHost}/api/{tenant}/benefit/`;
export const MANAGECODES_BASE_URL = `${backendHost}/api`;
export const DISTRIBUTION_LIST_BASE_URL = `${backendHost}/api/{tenant}/dl/`;
export const GENERIC_DISTRIBUTION_LIST_BASE_URL = `${backendHost}/api/dl/`;
export const VISUAL_STUDIO_BENEFIT_BASE_URL = `${backendHost}/api/{tenant}/benefit/vs`;
export const VISUAL_STUDIO_BENEFIT_DOWNLOAD_URL = `${backendHost}/api/{tenant}/vs/download`;
export const RD_PROFILE_BASE_URL = `${backendHost}/api/rd/UserProfiles/`;
export const MVP_PROFILE_BASE_URL = `${backendHost}/api/mvp/UserProfiles/`;
export const PROGRAM_PROFILE_BASE_URL = `${backendHost}/api/ProgramProfile/`;
export const MVP_PROGRAM_PROFILE_BASE_URL = `${backendHost}/api/mvp/ProgramProfile/`;
export const MVP_RETIRE_BASE_URL = `${backendHost}/api/mvp/retire/`;
export const RD_PROGRAM_PROFILE_BASE_URL = `${backendHost}/api/rd/ProgramProfile/`;
export const SITECONTENT_BASE_URL = `${backendHost}/api/SiteContent/`;
export const UPLOAD_CSV_FILE_SA_REGISTRATION_STATUS = `${backendHost}/api/UserProfiles/ApplicationFormStatus/Csv/Upload`;
export const SUBMIT_CSV_FILE_SA_REGISTRATION_STATUS = `${backendHost}/api/UserProfiles/ApplicationFormStatus/Csv/Submit`;
export const UPLOAD_CSV_FILE_SA_PROGRAM_STATUS = `${backendHost}/api/ProgramProfile/ProgramStatus/Csv/Upload`;
export const SUBMIT_CSV_FILE_SA_PROGRAM_STATUS = `${backendHost}/api/ProgramProfile/ProgramStatus/Csv/Submit`;
export const SITECONTENT_AWARD_PERIODS_BASE_URL = `${SITECONTENT_BASE_URL}awardperiods/`;
export const SITECONTENT_COUNTRYREGIONS_BASE_URL = `${SITECONTENT_BASE_URL}countryregions/`;
export const SITECONTENT_STATEPROVINCES_BASE_URL = `${SITECONTENT_BASE_URL}stateprovinces/`;
export const SITECONTENT_SCHOOLS_BASE_URL = `${SITECONTENT_BASE_URL}schools/`;
export const SITECONTENT_SOCIALNETWORKS_BASE_URL = `${SITECONTENT_BASE_URL}socialnetworks/`;
export const SITECONTENT_CLREGIONS_BASE_URL = `${SITECONTENT_BASE_URL}clregions/`;
export const SITECONTENT_ACTIVITY_EVENT_TYPES_BASE_URL = `${SITECONTENT_BASE_URL}activityeventtypes`;
export const INDUSTRY_FOCUS_BASE_URL = `${SITECONTENT_BASE_URL}industryfocuses/`;
export const TECHNICAL_EXPERTISE_BASE_URL = `${SITECONTENT_BASE_URL}technicalexpertises/`;
export const PROGRAM_LANGUAGE_BASE_URL = `${SITECONTENT_BASE_URL}programLanguages/`;
export const TECHNOLOGY_AREA_BASE_URL = `${SITECONTENT_BASE_URL}techfocusarea`;
export const CL_REGIONS_BASE_URL = `${SITECONTENT_BASE_URL}clregions/`;
export const GEO_DATA_BASE_URL = `${SITECONTENT_BASE_URL}geodata/`;
export const COMMON_DATA_BASE_URL = `${SITECONTENT_BASE_URL}Common/Data/`;
export const SITECONTENT_AWARD_KIT_SKU_BASE_URL = `${SITECONTENT_BASE_URL}skus/`;
export const AWARDCATEGORIES_BASE_URL = `${backendHost}/api/awardcategory/`;

// Access Control endpoints
export const ACCESS_CONTROL_BASE_URL = `${backendHost}/api/adminuser/`;
